import React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';
import { OrbotnikColourVariant, orbotnikColourByStyle } from '../../../types/types';

interface CommonProps {
  variant: OrbotnikColourVariant;
  tooltip?: string;
  className?: string;
}
interface ChipProps extends CommonProps {
  label: string;
  size?: 'small' | 'medium';
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export const ColoredChip: React.FC<ChipProps> = ({ label, variant, size, tooltip,className, onClick }) => {
    const chip = (
      <Chip
        className={className}
        label={label}
        size={size}
        onClick={onClick}
        sx={{
          ...orbotnikColourByStyle[variant],
          borderWidth: '1px',
          borderStyle: 'solid',
          borderRadius: '4px',
          cursor: 'default',
        }}
      />
    );
  
    return tooltip ? (
      <Tooltip title={tooltip} arrow>
        {chip}
      </Tooltip>
    ) : (
      chip
    );
};
interface TagProps extends CommonProps {
  children?: React.ReactNode;
}
export const ColoredTag: React.FC<TagProps> = ({ 
  variant, 
  tooltip, 
  className, 
  children 
}) => {
const boxElement = (
  <Box 
    sx={{ 
      ...orbotnikColourByStyle[variant],      
      display: "inline-block",
      borderWidth: "1px",
      borderStyle: "solid",
      // borderColor: "#fcfcfc",
      borderRadius: "4px",
      padding: "2px 5px",
      marginRight: "5px",
      cursor: "default",
      // color: "#6d6d6d",
      // backgroundColor: "#f5f5f5"
    }}
  >
    {children}
  </Box>
);

return tooltip ? (
  <Tooltip title={tooltip} arrow>
    {boxElement}
  </Tooltip>
) : (
  boxElement
);
};
